import $ from 'jquery'
import CryptoJS from 'crypto-js'
import serviceProvider from '../service-provider/service-provider.js'
import identityProvider from '../identity-provider/identity-provider.js'
import InvalidSpSessionError from '../service-provider/invalid-sp-session-error.js'
import ActionError from './action-error.js'
import NextStep from './next-step.js'
import InvalidIdpSessionError from '../identity-provider/invalid-idp-session-error.js'
import SpLogoutError from '../service-provider/sp-logout-error.js'
import Promise from 'promise'
import SessionResponse from '../service-provider/session-response.js'
import ActionTypes from './action-types.js'

var utils = function(){}

function makeRedirectFunc(url){
  return (element)=> {
    return new Promise((res)=> {
      let dom = element!==undefined ? element : document
      log('changing page location to ' + url)
      dom.location = url
      res()
    })
  }
}

function makeCreateSessionFunc(samlResponse){
  return (element)=> {
    log('attempting to create a session with sp for given saml response')
    return serviceProvider.createSession(samlResponse)
  }
}

function log(message){
  console.log('utils: ' + message)
}

function redirectTo500(){
  log('navigating to critical error page 500')
  return document.location = '/500'
}

utils.ensureAuthenticated = function(url, relayState, successCallback, options = {errorCallback:redirectTo500, element:document}){
  utils.isAuthenticated(url, relayState).then(successCallback).catch((error)=> {
    log('session not authenticated')
    if (error instanceof ActionError) {
      log('following next step for authentication...')
      error.nextStep.complete(options.element).then((sessionResponse)=>{
        log('next step successfully executed')
        if (sessionResponse instanceof SessionResponse) {
          successCallback(sessionResponse.jwt)
        }
      }).catch((err)=>{
        options.errorCallback(err)
      })
    }
    else {
      log('unable to get next step for authentication')
      if (options.errorCallback!==undefined) {
        log('executing terminal error function')
        options.errorCallback(error)
      }
    }
  })
}

utils.isAuthenticated = function(url, relayState){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      log('verifying session...')
      return serviceProvider.validateSession(url, relayState)
        .then(payload=>{
          log('successfully verified session with sp')
          promiseRes(payload)
        })
        .catch((error)=>{
          log('returned error')
          if (error instanceof InvalidSpSessionError) {
            log('no session with service provider, attempting to verify if a session exists at identity provider')
            return identityProvider.validateSession(error.samlRequest)
          }
          log('no saml request was returned with service provider error.  Unable to continue saml flow')
          promiseErr(error)
        })
        .then((response)=>{
          let message = 'next step: create session with service provider'
          log(message)
          let request = new NextStep(response.sp, makeCreateSessionFunc(response))
          promiseErr(new ActionError(ActionTypes.CREATE_SP_SESSION, message, request, response.samlRequest, response.relayState))
        })
        .catch((error)=>{
          let message = 'next step: redirect to login'
          log(message)
          if (error instanceof InvalidIdpSessionError) {
            let request = new NextStep(error.loginPage, makeRedirectFunc(error.loginPage))
            promiseErr(new ActionError(ActionTypes.REDIRECT_TO_LOGIN, message, request, error.samlRequest, error.relayState))
          }
          else
            promiseErr(error)
        })
    } catch (error) {
      promiseErr(new Error('error attempting to verify authentication status' + error))
    }
  })
}

utils.logout = function(url){
  return new Promise((promiseRes, promiseErr)=> {
    try {
      log('logging out session...')
      return serviceProvider.userInitiatedLogout(url)
        .then(()=>{
          log('successfully logged out of sp session, logout complete')
          promiseRes()
        })
        .catch((error)=>{
          log('userInitiatedLogout returned error')
          if (error instanceof SpLogoutError) {
            log('session present on service provider, attempting to destroy associated idp session and obtain logout saml response')
            identityProvider.destroySession(error.samlRequest).then((idpResponse)=>{
              log('received saml response, attempting to destroy service provider session')
              return serviceProvider.destroySession(idpResponse.samlResponse)
            }).then(()=>{
              log('successfully destroyed sp session, logout complete')
              promiseRes()
            }).catch((generalError)=>{
              let message = 'critical error whilst destroying session, unable to continue saml logout flow: ' + generalError.message
              log(message)
              promiseErr(generalError)
            })
          }else {
            log('no saml request was returned from service provider, unable to continue saml logout flow')
            promiseErr(error)
          }
        })
    } catch (error) {
      promiseErr(new Error('error attempting to request logout' + error))
    }
  })
}

utils.logoutAndRedirect = function(url, redirectFunc = makeRedirectFunc('/login'), errorRedirect = redirectTo500){
  utils.logout(url)
    .then(redirectFunc)
    .catch(errorRedirect)
}

utils.submitForm = function(form, element){
  log('preparing form for submission')
  if (element === undefined){
    log('no element given to host form, creating hidden div')
    element = document.createElement('div')
    element.setAttribute('style', 'display:none')
    document.body.appendChild(element)
    log('hidden div created')
  }
  element.innerHTML = form
  form = element.firstChild
  log('submitting form...')
  form.submit()
}

utils.submitBase64Form = function(base64Form, element){
  log('preparing to decode form')
  var form = utils.decodeBase64String(base64Form)
  log('form successfully decoded')
  utils.submitForm(form, element)
}

utils.decodeBase64String = value=> {
  var words = CryptoJS.enc.Base64.parse(value)
  return CryptoJS.enc.Utf8.stringify(words)
}

utils.extractLocation = function(httpResponse){
  try {
    let location = httpResponse.getResponseHeader('Location')
    log('extracted ' + location + ' from Location header')
    return location
  }catch (err){
    log('could not extract location from header')
    throw err
  }
}

utils.decodeBase64JwtToken = function(base64JwtToken){
  log('retrieving payload segment of jwt token: ' + base64JwtToken)
  let encodedString = base64JwtToken.split('.')[1]
  log('attempting to decode jwt token: ' + base64JwtToken)
  let decodedString = utils.decodeBase64String(encodedString)
  log('successfully decoded base64 jwt token: ' + decodedString)
  log('parsing jwt json')
  return JSON.parse(decodedString)
}

utils.ActionTypes = ActionTypes

export default utils


/** WEBPACK FOOTER **
 ** ./components/utils/utils.js
 **/